import React from 'react';

import styled from '@emotion/styled';

import { client } from '@admin/libraries/apollo';
import { useFacilityDetailsQuery, WarehouseOrDepotInput__Kind } from '@admin/schema';

const Hours = styled.div`
  margin-top: 4px;
`;

export const AddressDetails: React.FC<{
  facilityID: string;
  facilityType: string;
}> = ({ facilityID, facilityType }) => {
  const { data, loading } = useFacilityDetailsQuery({
    client,
    variables: {
      warehouseOrDepot: {
        id: facilityID,
        type: WarehouseOrDepotInput__Kind[facilityType as keyof typeof WarehouseOrDepotInput__Kind],
      },
    },
    skip: !(facilityType in WarehouseOrDepotInput__Kind),
  });

  const facility = data?.warehouseOrDepot;

  if (loading || !facility || facility.__typename !== 'Warehouse') return null;

  return (
    <div>
      <hr />
      <strong>Facility Access Hours: </strong>
      <div>
        {facility.accessHours.map((hours, index) => (
          <div key={index}>
            <Hours>{hours}</Hours>
          </div>
        ))}
      </div>
    </div>
  );
};
